export default function PublicOffer() {
  return (
    <div className="prose prose-sm max-w-none">
      <h1 className="text-2xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
        Публичная оферта
      </h1>

      <p className="text-gray-600 mb-4">
        Дата последнего обновления: 21 апреля 2026 года
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          1. Общие положения
        </h2>
        <p className="text-gray-700 mb-2">
          1.1. Настоящий документ является официальным предложением (публичной
          офертой) Исполнителя заключить договор на оказание услуг по генерации
          музыкальных композиций с использованием технологий искусственного
          интеллекта.
        </p>
        <p className="text-gray-700 mb-2">
          1.2. В соответствии с пунктом 2 статьи 437 Гражданского кодекса
          Российской Федерации (ГК РФ) в случае принятия изложенных ниже условий
          и оплаты услуг физическое или юридическое лицо, производящее оплату,
          становится Заказчиком (в соответствии с пунктом 3 статьи 438 ГК РФ
          акцепт оферты равносилен заключению договора на условиях, изложенных в
          оферте).
        </p>
        <p className="text-gray-700">
          1.3. Моментом полного и безоговорочного принятия Заказчиком
          предложения Исполнителя заключить договор оферты (акцептом оферты)
          считается факт оплаты услуг Заказчиком в порядке, описанном в
          настоящей оферте.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          2. Термины и определения
        </h2>
        <p className="text-gray-700 mb-2">
          <strong>Исполнитель</strong> — владелец и администратор Сервиса
          генерации песен.
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Заказчик</strong> — физическое или юридическое лицо,
          заключившее договор с Исполнителем на условиях настоящей оферты.
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Сервис</strong> — веб-приложение для генерации музыкальных
          композиций с использованием искусственного интеллекта.
        </p>
        <p className="text-gray-700">
          <strong>Услуга</strong> — генерация музыкальных композиций и
          предоставление доступа к файлам без водяных знаков в формате MP3.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          3. Предмет договора
        </h2>
        <p className="text-gray-700 mb-2">
          3.1. Исполнитель обязуется оказать Заказчику услуги по генерации
          музыкальных композиций на основе предоставленных Заказчиком данных
          (текст песни, музыкальный стиль, тип вокала), а Заказчик обязуется
          принять и оплатить эти услуги.
        </p>
        <p className="text-gray-700">
          3.2. Перечень и стоимость услуг указаны в разделе 4 настоящей оферты.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          4. Стоимость услуг и порядок оплаты
        </h2>
        <p className="text-gray-700 mb-2">
          4.1. Стоимость услуг по генерации и предоставлению доступа к двум
          вариантам музыкальной композии без водяных знаков составляет 199 (сто
          девяносто девять) рублей.
        </p>
        <p className="text-gray-700 mb-2">
          4.2. Исполнитель вправе в одностороннем порядке изменять стоимость
          услуг. Новая стоимость услуг вступает в силу с момента размещения
          информации на сайте Сервиса.
        </p>
        <p className="text-gray-700 mb-2">
          4.3. Оплата производится Заказчиком путем перечисления денежных
          средств через платежные системы-партнеры Сервиса (банковские карты,
          электронные кошельки и др.).
        </p>
        <p className="text-gray-700">
          4.4. Датой оплаты считается дата зачисления денежных средств на
          расчетный счет Исполнителя.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          5. Порядок оказания услуг
        </h2>
        <p className="text-gray-700 mb-2">
          5.1. Заказчик предоставляет данные для генерации композиции через
          интерфейс Сервиса:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Название песни</li>
          <li>
            Текст песни (или использует функцию автоматической генерации текста)
          </li>
          <li>Музыкальный стиль</li>
          <li>Тип вокала (мужской/женский)</li>
        </ul>
        <p className="text-gray-700 mb-2 mt-3">
          5.2. После получения данных Исполнитель генерирует две версии
          музыкальной композиции в течение 1-2 минут.
        </p>
        <p className="text-gray-700 mb-2">
          5.3. Заказчик получает доступ к прослушиванию обеих версий композиции
          с водяными знаками бесплатно.
        </p>
        <p className="text-gray-700 mb-2">
          5.4. После оплаты Заказчик получает доступ к скачиванию обеих версий
          композиции без водяных знаков в формате MP3.
        </p>
        <p className="text-gray-700">
          5.5. Доступ к скачиванию предоставляется немедленно после
          подтверждения оплаты.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          6. Права и обязанности сторон
        </h2>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          6.1. Исполнитель обязуется:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Оказать услуги надлежащего качества в установленные сроки</li>
          <li>Предоставить доступ к файлам после подтверждения оплаты</li>
          <li>Обеспечить конфиденциальность данных Заказчика</li>
        </ul>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          6.2. Исполнитель имеет право:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>
            Отказать в оказании услуг при нарушении Заказчиком условий настоящей
            оферты
          </li>
          <li>
            Привлекать третьих лиц для исполнения обязательств по договору
          </li>
          <li>Вносить изменения в настоящую оферту</li>
        </ul>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          6.3. Заказчик обязуется:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Своевременно и в полном объеме оплатить услуги</li>
          <li>Предоставить достоверные данные при использовании Сервиса</li>
          <li>Не использовать полученные материалы в незаконных целях</li>
          <li>Не распространять версии композиций с водяными знаками</li>
        </ul>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          6.4. Заказчик имеет право:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Требовать надлежащего оказания услуг</li>
          <li>
            Использовать полученные композиции в личных и коммерческих целях
            после оплаты
          </li>
          <li>Обращаться в службу поддержки по вопросам оказания услуг</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          7. Ответственность сторон
        </h2>
        <p className="text-gray-700 mb-2">
          7.1. За неисполнение или ненадлежащее исполнение обязательств по
          настоящему договору стороны несут ответственность в соответствии с
          законодательством Российской Федерации.
        </p>
        <p className="text-gray-700 mb-2">
          7.2. Исполнитель не несет ответственности за качество генерируемых
          композиций, которое зависит от алгоритмов искусственного интеллекта и
          предоставленных Заказчиком данных.
        </p>
        <p className="text-gray-700">
          7.3. Исполнитель не несет ответственности за временную недоступность
          Сервиса, вызванную техническими работами или обстоятельствами
          непреодолимой силы.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          8. Возврат денежных средств
        </h2>
        <p className="text-gray-700 mb-2">
          8.1. Возврат денежных средств возможен в следующих случаях:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>
            Техническая невозможность предоставления услуги по вине Исполнителя
          </li>
          <li>Двойное списание средств</li>
        </ul>
        <p className="text-gray-700 mb-2 mt-3">
          8.2. Возврат не производится, если Заказчик уже получил доступ к
          скачиванию композиций.
        </p>
        <p className="text-gray-700">
          8.3. Решение о возврате принимается Исполнителем в течение 5 рабочих
          дней с момента получения обращения от Заказчика.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          9. Интеллектуальная собственность
        </h2>
        <p className="text-gray-700 mb-2">
          9.1. После оплаты услуг Заказчик получает неисключительные права на
          использование сгенерированных композиций.
        </p>
        <p className="text-gray-700 mb-2">
          9.2. Заказчик вправе использовать композиции в коммерческих целях,
          публиковать на стриминговых платформах и в социальных сетях.
        </p>
        <p className="text-gray-700">
          9.3. Исполнитель сохраняет за собой право использовать данные о
          созданных композициях для улучшения алгоритмов Сервиса.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          10. Конфиденциальность
        </h2>
        <p className="text-gray-700">
          Вопросы обработки персональных данных и конфиденциальности
          регулируются Политикой конфиденциальности Сервиса.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          11. Срок действия договора
        </h2>
        <p className="text-gray-700">
          Договор вступает в силу с момента оплаты услуг Заказчиком и действует
          до момента полного исполнения сторонами своих обязательств.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          12. Разрешение споров
        </h2>
        <p className="text-gray-700 mb-2">
          12.1. Все споры и разногласия решаются путем переговоров.
        </p>
        <p className="text-gray-700">
          12.2. При невозможности урегулирования спора в досудебном порядке,
          спор подлежит рассмотрению в судебном порядке в соответствии с
          законодательством Российской Федерации.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          13. Прочие условия
        </h2>
        <p className="text-gray-700 mb-2">
          13.1. Настоящая оферта может быть изменена Исполнителем в
          одностороннем порядке. Новая редакция вступает в силу с момента
          размещения на сайте.
        </p>
        <p className="text-gray-700">
          13.2. Все приложения и дополнения к настоящей оферте являются ее
          неотъемлемой частью.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          14. Реквизиты и контакты
        </h2>
        <p className="text-gray-700 mb-2">
          Наименование: Сервис генерации песен
        </p>
        <p className="text-gray-700 mb-2">Email: support@music-generator.ru</p>
        <p className="text-gray-700">
          По вопросам оферты: legal@music-generator.ru
        </p>
      </section>
    </div>
  );
}
